import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=c2624c3c&scoped=true&"
import script from "./FlipBook.vue?vue&type=script&setup=true&lang=js&"
export * from "./FlipBook.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FlipBook.vue?vue&type=style&index=0&id=c2624c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2624c3c",
  null
  
)

export default component.exports